import React from "react";

import { useProfile } from "app/context";
import { Trans } from "app/utils";

import { makePatch } from "@culturehq/client";

import OrganizationRow from "components/common/OrganizationRow";
import { Icon } from "@culturehq/components";
import getUserName from "app/utils/getUserName";

const ProfileOrganizations = ({ onSelectedOrg, withDefault }) => {
  const { profile } = useProfile();

  const handleSelectOrganization = async organizationId => {
    const { user } = await makePatch("/profile/current_organization", { organizationId });
    if (onSelectedOrg) {
      return onSelectedOrg(user);
    }

    window.location.assign("/");
    return setTimeout(() => {
      window.location.href = "/feed";
    }, 500);
  };

  return (
    <div className="ProfileOrganizations col-sm-12">
      <div className="ProfileOrganizations__Container">
        <h1 className="ProfileOrganizations__Name">
          <Trans>Hi</Trans>
          {" "}
          {getUserName(profile)}
          {" "}
          👋
        </h1>
        <p className="ProfileOrganizations__Instructions">
          <Trans>Choose the organization you&apos;d like to log into</Trans>
        </p>
        {profile.organizations.map(organization => (
          <div className="ProfileOrganizations__Option" key={organization.id}>
            <OrganizationRow
              onSelectOrganization={handleSelectOrganization}
              organization={organization}
              currentOrganizationId={profile.organization.id}
              withDefault={withDefault}
            >
              <Icon className="Accordian__arrow" icon="chevron-right" />
            </OrganizationRow>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileOrganizations;
